import Apiservice from '../../api.service';
import { API_URL } from '../../../../common/config.js'
const apiService = Apiservice;


export default class GeneralAttendanceService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/kiosk`;
    }

    getByTypes(data={}){
        let url = `${this.#api}/user/get-by-type`;
        let param = {params: data};
        return apiService.query(url, param);
    }
}